import i18n from '../../locales/index';
import {
  LANGUAGE,
  DIRECTION,
  RESET,
  INIT_LANGUAGE,
  LOADING,
  AVAILABLE_LANGUAGES,
} from '../types';

import directions from '../../locales/directions';
import { DEFAULT_LANG } from '../../config';

const validLanguage = ['fa', 'en', 'ch'];

export const state = () => ({
  language: DEFAULT_LANG,
  direction: directions[DEFAULT_LANG],
});

export const getters = {
  // the first argument is the module's local state
  // the second argument is the getters object itself
  // the third argument is the rootState
  //
  // we have used ES6 object destructuring
  // to pull out the language from the local state object
  [LANGUAGE]({ language }) {
    return language;
  },

  [DIRECTION]({ direction }) {
    return direction;
  },

  [AVAILABLE_LANGUAGES]() {
    return validLanguage;
  },
};

// committing a mutation method can be done in components
// as follows: this.$store.commit('mutationName');
//
// notice that the functions MUST be synchronous
export const mutations = {
  // used 'stateObj' over the 'state'
  // according to the ESLint's 'no-shadow' rule
  /* eslint-disable no-param-reassign */
  // commented the rootState as it has not been implemented yet!
  // See: https://github.com/vuejs/vuex/issues/344
  [LANGUAGE](stateObj, /* rootState, */ language) {
    stateObj.language = language;
  },

  [DIRECTION](stateObj, /* rootState, */ direction) {
    stateObj.direction = direction;
  },

  [RESET](stateObj) {
    Object.assign(stateObj, state());
  },
};

function isValidLanguage(lang) {
  return validLanguage.indexOf(lang) !== -1;
}

// actions are reusable complex functions,
// shared between components to commit mutations and
// can be dispatched through components as follows:
// this.$store.dispatch('actionName');
//
// notice that actions can be asynchronous
export const actions = {
  // the first argument is the context store,
  // i.e. the locale module object
  [LANGUAGE]({ dispatch }, lang) {
    dispatch(LOADING, true);
    localStorage.setItem('language', lang);
    window.location.reload();
  },
  [INIT_LANGUAGE]({ commit }) {
    let lang = localStorage.getItem('language') || DEFAULT_LANG;
    if (!isValidLanguage(lang)) {
      lang = DEFAULT_LANG;
    }

    i18n.locale = lang;
    localStorage.setItem('language', lang);

    commit(LANGUAGE, lang);
    commit(DIRECTION, directions[lang]);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
